import { useMemo } from 'react';

import type { Line } from '~/api/common/types';
import type { UserLanguage } from '~/api/user/types';

import { useTable } from '~/components';
import { ColumnIds } from '~/constants/table';

import type { QuotationLineRow } from './QuotationLinesTable.hooks';

import { useQuotationLinesTableColumns } from './QuotationLinesTable.hooks';

type Props = {
  language: UserLanguage;
  lines: Line[];
};

export const QuotationLinesTable = ({ language, lines }: Props) => {
  const data = useMemo<QuotationLineRow[]>(() => lines.map((line, index) => ({ id: index, line })), [lines]);
  const hasDiscount = useMemo(() => lines.some((line) => line.type === 'entry' && line.discountType !== null), [lines]);

  const columns = useQuotationLinesTableColumns({ language });
  const [table, Table] = useTable({
    data,
    columns,
    manualPagination: true, // Show all rows
    state: { columnVisibility: { [ColumnIds.documentLinesDiscount]: hasDiscount } },
  });

  return (
    <Table.Root table={table}>
      <Table.Grid>
        <Table.Header />

        <Table.Body>{(row) => <Table.Row row={row} />}</Table.Body>
      </Table.Grid>
    </Table.Root>
  );
};
